import React from 'react';
import { SUPPORT_EMAIL, INSTAGRAM } from '../lib/config';
export function Footer() {
  return <footer className="w-full border-t border-gold-soft bg-ivory py-14" data-id="element-145" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-146" data-mp="32nukolv2nz0b">
        <p className="font-serif text-2xl text-ink" data-id="element-147" data-mp="32pfeg99kbdx4">Direct the Day™</p>
        <div className="rule-gold mx-auto mt-6 w-24" aria-hidden="true" data-id="element-148" data-mp="36oo9rik93jus" />
        <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-ink-soft" data-id="element-149" data-mp="3uf0md6qfy4rp">
          The word-for-word direction system for wedding photographers who refuse to wing
          someone&rsquo;s wedding day.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-ink-soft" data-id="element-150" data-mp="3ldalzbekzvhs">
          <li data-id="element-151" data-mp="3qc40n75ltsjj">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors hover:text-gold-dark" data-id="element-152" data-mp="3qblvtm4vm600">
              {SUPPORT_EMAIL}
            </a>
          </li>
          <li data-id="element-153" data-mp="2ezl2rv0zbveg">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-154" data-mp="2ew72qtfsfya6">
              {INSTAGRAM}
            </a>
          </li>
          <li data-id="element-155" data-mp="3gaz376r4yrlo">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-156" data-mp="3gb8s0r0g2sps">
              Terms &amp; Conditions
            </a>
          </li>
          <li data-id="element-157" data-mp="3v5n4s9tf15w0">
            <a href="#" className="transition-colors hover:text-gold-dark" data-id="element-158" data-mp="3q8mzi14e475y">
              Privacy Policy
            </a>
          </li>
        </ul>

        <p className="mt-10 text-[11px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-159" data-mp="81yyamcgo45k">
          © 2026 Direct the Day™. All rights reserved.
        </p>
      </div>
    </footer>;
}